import { atom } from 'jotai';

export const companiesLoadingAtom = atom(true);
